import request from '@/utils/request';
import { normalizeObjectPropsFromRemote, parseJSON, hash2obj } from '@/utils';
import md5 from 'blueimp-md5';
import store from '@/store';
import { sendError } from '@/utils/sentry';
import dayjs from 'dayjs';
import qs from 'qs';

export const getImageTranslate = params => {
  return request(`//api.tosoiot.com/?Action=GetImageTranslateQuery&RequestId=${params.RequestId}`).then(postProcessor);
  function postProcessor(res) {
    if (res.Data.Content) {
      res.Data = { ...res.Data, ...res.Data.Content };
    }
    const { Orc, TargetLanguage } = res.Data;
    res.Data.Orc = (Orc || []).map(item => {
      return normalizeObjectPropsFromRemote({ ...item, TargetLanguage });
    });
    // console.log(res.Data);
    return res;
  }
};

export const uploadImage = params => {
  return request.post('//www.tosoiot.com/open/img/upload-fix-content', {
    filename: params.filename,
    'img-content': params.base64,
    requestId: params.requestId,
  });
};

export const getImageMimeType = url => {
  return request.get(url, { verboseRes: true }).then(res => {
    return (res.headers['content-type'] || '').split('/')[1] || 'png';
  });
};

export const getImageList = ids => {
  return request.get(`//api.tosoiot.com/?Action=GetImageTranslateBatchQuery&RequestIds=${ids}`).then(res => {
    const { Content } = res.Data;
    try {
      const result = Object.keys(Content).reduce((map, item) => {
        const value = Content[item];
        map[item] = value;
        if (value.Content) {
          map[item] = { ...value, ...value.Content };
        }
        return map;
      }, {});

      return result;
    } catch (err) {
      console.error(err);
      return Content;
    }
  });
};

export const translateText = ({
  SourceLanguage,
  TargetLanguage,
  Text,
  Type,
  isInERP,
  TextTransSign,
  CommitTime,
  TextTransKey: erpTextTransKey,
}) => {
  const { UserKey, TextTransKey } = store.state.app.userInfo;
  const encodedText = encodeURIComponent(Text);
  const Sign = isInERP
    ? TextTransSign
    : md5(`${SourceLanguage}_${TargetLanguage}_${encodedText}_${UserKey}_${TextTransKey}`);
  const query = {
    SourceLanguage,
    TargetLanguage,
    Text: encodedText,
    TextTransKey,
    Sign,
    Type,
  };
  if (isInERP) {
    Object.assign(query, { CommitTime, TextTransKey: erpTextTransKey });
  }
  return request
    .post(`//api.tosoiot.com/?Action=GetTextTranslate`, qs.stringify(query), {
      silent: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
    .then(res => res.Data);
};

// 批量download
export const batchDownload = urls => {
  return request.post(`/img-trans/batch-download/`, { urls }, { responseType: 'blob' }).then(res => {
    const url = URL.createObjectURL(res);
    const link = document.createElement('a');
    link.href = url;
    link.download = `xiangji_${dayjs(new Date()).format('YYYYMMDD_HHmmss')}.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
};

export function getUserInfo() {
  return request.get('/user/read', { silent: true });
}

export function setCache(data) {
  // const headers = { type: 'application/json' };
  // const blob = new Blob([JSON.stringify(data)], headers);
  // navigator.sendBeacon('/cache/set', blob);
  const body = { requestId: data.requestId, content: JSON.stringify(data?.v || {}), type: 'image-editor-cache' };
  request.post('/cache/request-data-set', body, { silent: true }).catch(err => {
    sendError('setcacheError', err);
  });
}

export function getCache(data) {
  const body = { requestId: data.requestId, type: 'image-editor-cache' };
  return request
    .post('/cache/request-data-get', body, { silent: true })
    .then(res => parseJSON(res.data.content, null))
    .catch(err => {
      sendError('getcacheError', err);
    });
}

export const getUserFontList = data => {
  return request.post('/user-font/get', data).then(res => {
    try {
      return (res.data.list || []).map(i => {
        return {
          ...i,
          fontNameOrigin: i.fontName,
          fontName: `custom-${i.fontName}`,
          lang: i.supportCountry.split(','),
        };
      });
    } catch (err) {
      return [];
    }
  });
};

export const imagePainting = data => {
  let { AigcKey } = hash2obj();
  if (process.env.NODE_ENV === 'development') {
    AigcKey = '4703885621';
  }
  return request
    .post(
      'https://api.tosoiot.com/image/v1/aigc/execute/cleanup',
      {
        task_id: data.requestId,
        image: data.image,
        mask: data.mask,
      },
      {
        headers: {
          'X-API-Key': AigcKey,
        },
      }
    )
    .then(res => {
      return res.Data.results[0].image;
    });
};

export const createOrUpdateImgGroup = data => {
  debugger;
  return request.post('//api.tosoiot.com/img-group/create', data).catch(err => {});
};

export const translateByUrls = query => {
  const { Action, ...rest } = query;

  const domain = 'api.tosoiot.com';
  return request.post(`//${domain}/?Action=${Action}`, qs.stringify(rest), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

/**
 *
 * @param {*} urls
 * @param {*} transConfig
 * @param {*} before
 * @param {*} after
 * @param {*} names
 * @returns
 */
export const doTranslateByUrls = async (url, before, after, names) => {
  debugger;
  // userStore = userStore || useUserStore();
  // appStore = appStore || useAppStore();
  // uploadStore = uploadStore || useUploadStore();
  const groupuid = +new Date();
  // const { textTransType, from = 2, productTextProtect } = transConfig;
  // const { productType } = appStore;
  // const { user_key, img_trans_key } = userStore.userInfo;
  const user_key = 3958008768;

  // 设置图片翻译抽屉框展示的图片
  // let list = [];
  // list = urls.map((url, idx) => {
  //   return {
  //     url,
  //     gid: groupuid,
  //     file: {
  //       $tempGroupId: groupuid,
  //       $productType: appStore.currentProduct,
  //     },
  //     uid: groupuid + '' + idx,
  //   };
  // });
  const timestamp = Math.floor(+new Date() / 1000);

  // 翻译的参数
  const params = {
    Action: 'GetImageTranslate',
    Url: url,
    SourceLanguage: 'CHS',
    TargetLanguage: 'KOR',
    ImgTransKey: '1199144185',
    CommitTime: timestamp,
    NeedWatermark: 0,
    Sign: '',
    NeedRmUrl: 0,
    ProductTextProtect: 0,
    Sync: 2,
    From: 2,
  };

  // if (textTransEngineMap[textTransType].EngineType) {
  //   params.EngineType = textTransEngineMap[textTransType].EngineType;
  // }
  if (names && names.length > 0) {
    params.FileNames = names.join(',');
  }

  params.Sign = md5(`${timestamp}_${user_key}_${params.ImgTransKey}`);

  try {
    // before && before(groupuid, list, params);
    // 调用url翻译接口
    const res = await translateByUrls(params);

    // 如果有after事件，并且返回了true，那么终止后面的操作
    // if (after && after(res)) {
    //   return false;
    // }

    const { Content } = res.Data;
    // const firstOne = list[0];
    const sourceLanguage = params.SourceLanguage;
    const targetLanguage = params.TargetLanguage;
    // 创建图片组
    const res2 = await createOrUpdateImgGroup({
      // type: getProductType(productType.currentProduct, textTransType),
      type: 1,
      sourceLanguage,
      targetLanguage,
      requestId: Content,
      order: -1,
      // webKey: firstOne.file.$tempGroupId,
      needRmUrl: 0,
      from: 2,
    });
    console.log({ res2 });
    // return { groupuid, params, list };
  } catch (e) {
    console.log({ e });
    throw e;
  }
};
